export default "__VITE_ASSET__fIhICEEW__"